module.exports = __webpack_public_path__ + "img/Group 2.5a3dc430.svg";